import { Locale } from '@core/internationalize/models/locale';

const LOGIN_LOCALE_KEY = 'members:loginLocale';

/**
 * Store the active locale before the Auth0 redirect.
 * Stores nothing (and removes any stale entry) when the locale is the default
 * (en-US) because `/home` is already the correct fallback for US users.
 */
export const storeLoginLocale = (locale: Locale | undefined): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  if (locale && locale !== Locale.EnglishUnitedStates) {
    try {
      sessionStorage.setItem(LOGIN_LOCALE_KEY, locale);
    } catch {
      try {
        sessionStorage.removeItem(LOGIN_LOCALE_KEY);
      } catch {
        // ignore
      }
    }
  } else {
    try {
      sessionStorage.removeItem(LOGIN_LOCALE_KEY);
    } catch {
      // ignore
    }
  }
};

/**
 * Read and immediately clear the stored login locale.
 * Returns null when no locale was persisted (e.g. US locale or sessionStorage
 * is unavailable).
 */
export const consumeLoginLocale = (): Locale | null => {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const stored = sessionStorage.getItem(LOGIN_LOCALE_KEY);
    if (stored) {
      sessionStorage.removeItem(LOGIN_LOCALE_KEY);
      return stored as Locale;
    }
  } catch {
    // sessionStorage may be blocked
  }
  return null;
};
